var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("div", { staticClass: "boss-layout-block" }, [
      _c(
        "div",
        {
          staticClass:
            "boss-text boss-layout boss-layout-gap-large pega-print-selection-top",
        },
        [
          _c("div", [_vm._v("人事担当者")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pega-print-staff-name-area pega-pre-wrap",
              attrs: { "data-test": "responsible-staff-name" },
            },
            [_vm._v(_vm._s(_vm.selectedResponsibleStaffName))]
          ),
          _vm._v(" "),
          _c("div", [_vm._v("備考")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pega-pre-wrap", attrs: { "data-test": "remarks" } },
            [_vm._v(_vm._s(_vm.remarks))]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "boss-table-wrap pega-visible" }, [
      _c(
        "table",
        { staticClass: "boss-table-4 pega-th-color-important" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.selections, function (selection, i) {
            return _c("entry-print-selection-outline", {
              key: i,
              attrs: { selection: selection },
            })
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("選考フェーズ")]),
      _vm._v(" "),
      _c("th", [_vm._v("評価")]),
      _vm._v(" "),
      _c("th", [_vm._v("評価コメント")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }